export const UMB_MEDIA_MENU_ALIAS = 'Umb.Menu.Media';
